import { GlassTooltip } from "@/components/GlassTooltip";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/Card";
import * as styles from "@/pages/AnalyticsPage.styles";
import * as shared from "@/styles/shared";
import type { SpendingPeriod } from "@shared/types/analytics";
import { BarChart, BarChart3 } from "lucide-react";
import { Bar, CartesianGrid, BarChart as RechartsBarChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface MonthlySpendingChartProps {
  spending: SpendingPeriod[];
  title: string;
  noDataLabel: string;
  noDataHint?: string;
}

const MonthlySpendingChart = ({ spending, title, noDataLabel, noDataHint }: MonthlySpendingChartProps) => {
  return (
    <>
      <CardHeader className={styles.chartCardHeader}>
        <div className={styles.chartHeaderRow}>
          <div className={styles.chartHeaderIcon}>
            <BarChart3 className={shared.iconSm} />
          </div>
          <CardTitle className={styles.chartTitle}>{title}</CardTitle>
        </div>
      </CardHeader>
      <CardContent>
        {!spending.length ? (
          <div className={styles.emptyState}>
            <BarChart className={styles.emptyIcon} />
            <p className={styles.noData}>{noDataLabel}</p>
            {noDataHint && <p className={styles.noDataHint}>{noDataHint}</p>}
          </div>
        ) : (
          <ResponsiveContainer width="100%" height={300}>
            <RechartsBarChart data={spending}>
              <CartesianGrid strokeDasharray="3 3" className={styles.gridLine} />
              <XAxis dataKey="period" className={styles.chartAxis} tick={{ fill: "hsl(var(--muted-foreground))" }} fontSize={12} />
              <YAxis
                className={styles.chartAxis}
                tick={{ fill: "hsl(var(--muted-foreground))" }}
                fontSize={12}
                tickFormatter={(v: number) => `${v}`}
              />
              <Tooltip content={<GlassTooltip />} />
              <Bar dataKey="total" radius={[6, 6, 0, 0]} className={styles.barFill} />
            </RechartsBarChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </>
  );
};

export { MonthlySpendingChart };
